import React from "react"

const NetworkManageContext = React.createContext({})

const { Provider, Consumer } = NetworkManageContext

export { Provider, Consumer, NetworkManageContext }
